import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//Servicios
import { AuthGuardService } from '@/app/services/security/auth-guard.service';
import { RoleGuardService } from '@/app/services/security/role-guard.service';

//Componentes (páginas) de la app
import { LoginComponent } from '@/app/components/login/login.component';
import { CargasComponent } from '@/app/components/cargas/cargas.component';
import { ReportesComponent } from '@/app/components/reportes/reportes.component';
import { ListaUsuariosComponent } from '@/app/components/catalogos/Usuarios/lista-usuarios/lista-usuarios.component';
import { ListaEstacionesComponent } from '@/app/components/catalogos/Estaciones/lista-estaciones/lista-estaciones.component';
import { ListaActivosComponent } from '@/app/components/activos/lista-activos/lista-activos.component';
import { ListaCombustiblesComponent } from '@/app/components/catalogos/Combustibles/lista-combustibles/lista-combustibles.component';
import { ListaFamiliaequipoComponent } from '@/app/components/catalogos/FamiliasEquipos/lista-familiaequipo/lista-familiaequipo.component';
import { ListaAlmacenesComponent } from '@/app/components/catalogos/Almacenes/lista-almacen/lista-almacenes.component';
import { ObtenerCompaniaComponent } from '@/app/components/catalogos/Compania/obtener-compania/obtener-compania.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'cargas', component: CargasComponent, canActivate: [AuthGuardService], },
  { path: 'estaciones', component: ListaEstacionesComponent, canActivate: [RoleGuardService], data: { expectedRole: [1] } },
  { path: 'combustibles', component: ListaCombustiblesComponent, canActivate: [AuthGuardService],},
  { path: 'familias', component: ListaFamiliaequipoComponent, canActivate: [RoleGuardService],data:{expectedRole:[1]} },
  { path: 'almacenes', component: ListaAlmacenesComponent, canActivate: [AuthGuardService], },
  { path: 'reportes', component: ReportesComponent, canActivate: [AuthGuardService] },
  { path: 'usuarios', component: ListaUsuariosComponent, canActivate: [RoleGuardService],data:{expectedRole:[1]} },
  { path: 'compania', component: ObtenerCompaniaComponent, canActivate: [AuthGuardService], },
  { path: 'activos',component: ListaActivosComponent,canActivate: [AuthGuardService], },
  { path: '**', pathMatch: 'full', redirectTo: 'login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
